<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter"><a id="page24"></a><span href="#/OEBPS/toc#c03" id="c03" title="Link target outside of Sample">Salads</span></h1>
<p class="graphic"><img alt="images" src="OEBPS/images/24-1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c03.vue?82b3675e